import './Timer.css'
import * as React from 'react'

export enum TimerState {
    START, STOP
}

class TimerViewState {
    public duration: number = 0
    public seconds: number = 0
    public minutes: number = 0
}

class TimerProps {
    public action: TimerState
}

class Timer extends React.Component<TimerProps, TimerViewState> {
    private intervalId: any

    constructor(props: TimerProps) {
        super(props)
        this.start = this.start.bind(this)
        this.stop = this.stop.bind(this)
        this.state = new TimerViewState()
    }

    public componentWillUpdate(nextProps: TimerProps, nextState: TimerViewState) {
        let resetTimer = false
        switch (nextProps.action) {
            case TimerState.START:
                this.start()
                break
            case TimerState.STOP:
                this.stop()
                resetTimer = nextState.duration > 0
                break
        }
        if (resetTimer) {
            this.setState(new TimerViewState())
        }
    }

    public render() {
        return (<div className="Timer">{this.state.minutes < 10 ? "0" : ""}{this.state.minutes}:{this.state.seconds < 10 ? "0" : ""}{this.state.seconds}</div>)
    }

    private start() {
        if (this.intervalId === undefined) {
            this.intervalId = setInterval(() => {
                const tempDuration = this.state.duration + 1000
                const tempMinutes = Math.floor(tempDuration / (1000 * 60))
                const tempSeconds = (tempDuration - (tempMinutes * 1000 * 60)) / 1000
                this.setState({ seconds: tempSeconds, minutes: tempMinutes, duration: tempDuration })
            }, 1000)
        }
    }

    private stop() {
        if (this.intervalId !== undefined) {
            clearInterval(this.intervalId)
            this.intervalId = undefined
        }
    }
}

export default Timer


// WEBPACK FOOTER //
// ./src/components/stream/timer/Timer.tsx